import { H1 } from "../../components/Text/Text";
import SendToBroadcastersBody from "./SendToBroadcastersBody";
import Button, { ButtonModeE } from "../../components/Button/Button";
import { BroadcasterT } from "../../models/models";

import styles from './sendToBroadcasters.module.scss';

export default (
    broadcasters: BroadcasterT[],
    campaignId: number,
    deliveryNumber: number,
    id: number,
    removePopup: () => void,
    refetch: () => void,
    errors: {
        name: string,
        incorrectLength: boolean;
        resolutionError: boolean,
        encodingError: boolean,
    }[],
) => {
    return ({
        header: <H1>Send to broadcasters</H1>,
        body: (
            <SendToBroadcastersBody
                broadcasters={broadcasters}
                campaignId={campaignId}
                refetch={refetch}
                deliveryNumber={deliveryNumber}
                id={id}
                errors={errors}
            />
        ),
        footer: (
            <div className={styles.footerButtonsWrapper}>
                <Button
                    mode={ButtonModeE.OUTLINED}
                    onClick={removePopup}
                >
                    Cancel
                </Button>
                <Button
                    form="send-to-broadcasters"
                    useGlobalLoading
                    disabled={errors.length > 0}
                >
                    Send to broadcasters
                </Button>
            </div>
        ),
        className: styles.popupWrapper,
    });
};